import Generic from 'src/models/generic/Generic'
import Model, { executeMutation, ID, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Site from 'src/models/site/Site'

export const STRIPE_ACCOUNT_STATE = Object.freeze({
  ACTIVE: 'active',
  NEEDS_ATTENTION: 'needs_attention',
  ERROR: 'error',
  ONBOARDING: 'onboarding'
})
export const ALL_STRIPE_ACCOUNT_STATES = _.values(STRIPE_ACCOUNT_STATE)
Object.freeze(ALL_STRIPE_ACCOUNT_STATES)

export default class SiteStripeConfiguration extends Model {
  static name = 'SiteStripeConfiguration'

  static level = MODEL_LEVEL.SITE

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      site: {
        type: Site,
        output: true
      },
      stripeAccountId: {
        type: String,
        default: null
      },
      state: {
        type: String,
        output: true,
        excludeFromDefault: true
      },
      enabledPaymentMethodsList: {
        type: JsonArray,
        output: true
      },
      transferOptions: {
        type: JsonObject,
        mergeDefault: true,
        default () {
          return {
            transfer_name: this.name,
            date_position: 'prefix'
          }
        },
        excludeFromDefault: true
      },
      stripePayoutBankAccounts: {
        type: JsonArray,
        default: () => ([]),
        excludeFromDefault: true
      },
      paymentMethodConfiguration: {
        type: JsonObject,
        output: true
      },
      domainConfiguration: {
        type: JsonObject,
        output: true,
        excludeFromDefault: true
      },
      payoutSchedule: {
        type: String,
        output: true,
        excludeFromDefault: true
      },
      accountType: {
        type: String,
        output: true,
        excludeFromDefault: true
      },
      dashboardUrl: {
        type: String,
        output: true,
        excludeFromDefault: true
      },
      accountRequirements: {
        type: JsonObject,
        output: true,
        excludeFromDefault: true
      },
      stripeBankAccounts: {
        type: JsonArray,
        excludeFromDefault: true,
        output: true
      },
      accountOnboarded: {
        type: Boolean,
        output: true,
        excludeFromDefault: true
      }
    }

    this.queries = {
      stripeAccountSession: {
        arguments: {
          configurationId: {
            type: ID,
            required: true
          },
          isAccountRequirementBanner: {
            type: Boolean,
            default: false
          }
        },
        results: {
          value: Generic
        }
      },
      stripeDisputeSession: {
        arguments: {
          paymentId: {
            type: ID,
            required: true
          }
        },
        results: {
          value: Generic
        }
      }
    }

    this.mutations = {
      generateOnboardingLink: {
        arguments: {
          siteStripeConfigurationId: {
            type: ID,
            required: true
          }
        },
        results: {
          onboardingLink: String
        }
      },
      createCustomConnectAccount: {
        arguments: {
          siteStripeConfigurationId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean
        }
      },
      createStandardConnectAccount: {
        arguments: {
          siteStripeConfigurationId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean
        }
      }
    }
  }

  async generateOnboardingLink () {
    const results = await executeMutation('generateOnboardingLink', {
      siteStripeConfigurationId: this.id
    },
    {
      onboardingLink: String
    })

    return results?.data?.onboardingLink
  }

  async createCustomConnectAccount () {
    const results = await executeMutation('createCustomConnectAccount', {
      siteStripeConfigurationId: this.id
    }, { success: true })

    return results?.data?.success
  }

  async createStandardConnectAccount () {
    const results = await executeMutation('createStandardConnectAccount', {
      siteStripeConfigurationId: this.id
    }, { success: true })

    return results?.data?.success
  }
}
